export default __webpack_public_path__ + "static/media/referral-reward-en.a9e49cbe.svg";